import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { AccessorialRepository } from '../infra/AccessorialRepository'

export type GetAccessorialRatesFactoryDependencies = {
  accessorialRepository: AccessorialRepository
}

export function getAccessorialRatesFactory({
  accessorialRepository,
}: GetAccessorialRatesFactoryDependencies) {
  return async function get(carrierInvite: string, config?: { signal?: AbortSignal }) {
    return accessorialRepository.getAccessorialRates(carrierInvite, config)
  }
}

export function getAccessorialRates(carrierInvite: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const accessorialRepository = new AccessorialRepository({ httpClient })
  const get = getAccessorialRatesFactory({ accessorialRepository })
  return get(carrierInvite, config)
}
